import { useEffect, useRef } from 'react';

export function useFilterKeyboardShortcuts(
  filterContainerRef: React.RefObject<HTMLElement | null>,
  handleSearch: () => void,
  onClearValue: () => void,
  isDisabled?: boolean
) {
  const searchRef = useRef(handleSearch);
  const clearRef = useRef(onClearValue);
  const disabledRef = useRef(isDisabled);
  searchRef.current = handleSearch;
  clearRef.current = onClearValue;
  disabledRef.current = isDisabled;

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (disabledRef.current) return;
      if (e.key !== 'Enter') return;
      if (!filterContainerRef.current) return;
      const active = document.activeElement as HTMLElement | null;
      if (active?.tagName === 'TEXTAREA') return;
      if (active?.isContentEditable) return;
      if (active?.closest('[role="dialog"]')) return;

      e.preventDefault();
      if (e.shiftKey) {
        clearRef.current();
      } else {
        searchRef.current();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [filterContainerRef]);
}
